export default "__VITE_ASSET__CBDT14u$__"